import { ChangeDetectionStrategy, Component, Input } from "@angular/core";
import { Router } from "@angular/router";
import { UntilDestroy } from "@ngneat/until-destroy";
import { FOLLOWING_WIDGET_MAX_ITEMS } from "@helpers/constants";
import { WatchlistWidgetViewModel } from "@modules/watchlist/domain/+state/watchlist-widget/watchlist-widget.facade";

@UntilDestroy()
@Component({
	selector: "watchlist-widget",
	templateUrl: "./watchlist-widget.component.html",
	styleUrls: ["./watchlist-widget.component.scss"],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false
})
export class WatchlistWidgetComponent {
	@Input()
	public vm: WatchlistWidgetViewModel = undefined;
	@Input() isLimOrdEnabled: boolean = false;
	public WATCHLIST_WIDGET_MAX_ITEMS: number = FOLLOWING_WIDGET_MAX_ITEMS;

	public constructor(private router: Router) {}

	public openWatchlist(): void {
		this.router.navigate(["/watchlist"]);
	}
}
